import strFunc from "@/lib/lyg/string";
import DatePicker from "react-datepicker";
import { ko } from "date-fns/esm/locale";
import DateFunc from '@/lib/lyg/date_func';
import { customHeaderFunc } from '@/pcomponents/common/date_picker/custom_header';
import { CustomInputWrite } from '@/pcomponents/common/date_picker/custom_input';

function WriteSupplyArea(props: any) {
  let myProps = {
    supply_row_data: {},
    set_supply_row_data: (inData: any) => { },
    Style: {},
    ...props
  };
  let supply_row_data = myProps.supply_row_data;
  let cal_money_col_arr = [
    "a_money",
    "a_discount_money",
    "a_point_money"
  ];

  const onChangeDatePicker = (key: string, date: Date) => {
    let date_str = DateFunc.get_date_format(date, "Y-m-d");
    myProps.set_supply_row_data({
      ...supply_row_data,
      ...{ [key]: date_str }
    });
  };

  const handleInput = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    let change_row_data = { ...supply_row_data };
    change_row_data[name] = value;
    if (strFunc.str_in_array(name, cal_money_col_arr) != -1) {
      change_row_data.a_money_sum = get_supply_sum_by_calc(change_row_data);
    }
    myProps.set_supply_row_data(change_row_data);
  };

  const get_supply_sum_by_calc = (inData: any) => {
    let opt_obj = {
      a_money: 0,
      a_discount_money: 0,
      a_point_money: 0,
      ...inData
    };
    let a_money = parseInt(strFunc.uncomma(opt_obj.a_money));
    let a_discount_money = parseInt(strFunc.uncomma(opt_obj.a_discount_money));
    let a_point_money = parseInt(strFunc.uncomma(opt_obj.a_point_money));
    let a_money_sum = a_money - a_discount_money - a_point_money;
    if (a_money_sum < 0) {
      a_money_sum = 0;
    }
    return a_money_sum;
  };

  return (
    <div className="write_table_small">
      <table>
        <colgroup>
          <col width={"100px"}></col>
          <col width={"40%"}></col>
          <col width={"100px"}></col>
          <col width={"40%"}></col>
        </colgroup>
        <tbody>
          <tr>
            <th>제목</th>
            <td>
              <input className="row-input" name="a_title"
                value={supply_row_data.a_title}
                autoComplete="off"
                onChange={handleInput} />
            </td>
            <th>청구일</th>
            <td>
              <DatePicker
                selected={supply_row_data.a_date != "" ? new Date(supply_row_data.a_date) : null}
                onChange={(date: Date) => {
                  onChangeDatePicker("a_date", date);
                }}
                locale={ko}
                dateFormat="yyyy-MM-dd"
                customInput={<CustomInputWrite />}
                renderCustomHeader={customHeaderFunc}
              />
            </td>
          </tr>
          <tr>
            <th>청구금</th>
            <td>
              <input className="row-input text-right" name="a_money"
                value={strFunc.comma(supply_row_data.a_money)}
                autoComplete="off"
                onClick={(e) => {
                  e.currentTarget.select();
                }}
                onChange={handleInput} />
            </td>
            <th>할인</th>
            <td>
              <input className="row-input text-right" name="a_discount_money"
                value={strFunc.comma(supply_row_data.a_discount_money)}
                autoComplete="off"
                onClick={(e) => {
                  e.currentTarget.select();
                }}
                onChange={handleInput} />
            </td>
          </tr>
          <tr>
            <th>청구합계</th>
            <td className="text-right" style={{color:"blue", fontWeight:"bold"}}>
              {strFunc.comma(supply_row_data.a_money_sum)} 원
            </td>
            <th>메모</th>
            <td>
              <input className="row-input" name="a_memo"
                value={supply_row_data.a_memo}
                autoComplete="off"
                onChange={handleInput} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default WriteSupplyArea;